<template lang="pug">
  div
    template(v-for="zone in zonelist")
      v-divider.basic300(style="border: 2px solid;")
      div.mt-3(:key="zone.id")
        y-checkbox(v-model="zone.check" :color="$vuetify.theme.themes[$theme].info500" @change="changeZone(zone)")
          template(v-slot:label)
            div.s2.my-autobasic700--text {{ zone.name }}
        v-divider.basic300
        template(v-for="rate in zone.rates")
          div.pl-6.my-3(:key="rate.id")
            y-checkbox(v-model="rate.check" :color="$vuetify.theme.themes[$theme].info500" @change="changeRate(rate)")
              template(v-slot:label)
                div.p2.my-autobasic700--text {{ rate.description }}
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'LocalDeliveryRates',
  props: ['zones', 'manualRates', 'company'],
  data: () => ({
    zonelist: []
  }),
  mounted () {
    this.checkZoneList()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    checkZoneList () {
      if (this.zones && this.zones.length > 0) {
        this.zones.forEach(o => {
          if (o.enabled && o.shipping_methods.includes('manual')) {
            let data = {
              id: o.id,
              name: o.name,
              rates: this.manualRates.filter(f => f.shipping_zone === o.id).map(m => { return { ...m, check: m.fulfilment_type === 'local_delivery' }}),
              check: this.manualRates.filter(f => f.shipping_zone === o.id && f.fulfilment_type === 'local_delivery').length > 0
            }
            this.zonelist.push(data)
          }
        })
      }
    },
    changeZone (zone) {
      if (zone.check) {
        if (zone.rates.filter(f => f.check).length === 0) {
          zone.rates.forEach(o => {
            this.updateFulfilmentType(o, true)
            this.$set(o, 'check', true)
          })
        }
      } else {
        zone.rates.forEach(o => {
          this.updateFulfilmentType(o, false)
          this.$set(o, 'check', false)
        })
      }
    },
    changeRate (rate) {
      this.updateFulfilmentType(rate, rate.check)
    },
    updateFulfilmentType (rate, check) {
      const type = check ? 'local_delivery' : 'courier'
      this.$axios.patch(`/shipping/settings/${this.company.slug}/manual_shippings/${rate.id}`, { fulfilment_type: type })
        .then(() => {
          this.checkRateCheckbox(rate)
          this.checkZoneCheckbox(rate.shipping_zone)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    checkRateCheckbox (rate) {
      let zoneIdx = this.zonelist.map(m => m.id).indexOf(rate.shipping_zone)
      let rateIdx = this.zonelist[zoneIdx].rates.map(m => m.id).indexOf(rate.id)
      if (rate.check) {
        this.$set(this.zonelist[zoneIdx].rates[rateIdx], 'fulfilment_type', 'local_delivery')
      } else {
        this.$set(this.zonelist[zoneIdx].rates[rateIdx], 'fulfilment_type', 'courier')
      }
    },
    checkZoneCheckbox (zone) {
      let idx = this.zonelist.map(m => m.id).indexOf(zone)
      if (this.zonelist[idx].rates.filter(f => f.check).length > 0) {
        this.$set(this.zonelist[idx], 'check', true)
      } else if (this.zonelist[idx].rates.filter(f => !f.check).length === 0) {
        this.$set(this.zonelist[idx], 'check', true)
      } else if (this.zonelist[idx].rates.filter(f => f.check).length === 0) {
        this.$set(this.zonelist[idx], 'check', false)
      }
    }
  }
}
</script>